import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import english from "flatpickr/dist/l10n/default.js"

const LOCALES = {
  'es-CL': Spanish,
  'en-US': english
}

export default class extends Controller {
  static targets = ["input"]
  static values = { options: Object }

  connect() {
    this.initializeDatepicker()
  }

  disconnect() {
    if (this.flatpickr) {
      this.flatpickr.destroy()
    }
  }

  initializeDatepicker() {
    const selectedLocale = LOCALES[this.optionsValue.locale]

    const config = {
      dateFormat: this.optionsValue.dateFormat,
      minDate: this.optionsValue.minDate,
      maxDate: this.optionsValue.maxDate,
      allowInput: true,
      disableMobile: true,
      wrap: true,
      mode: this.optionsValue.mode,
      // allowInvalidPreload: true,
      // noCalendar: false,
      // onValueUpdate: (selectedDates, dateStr, instance) => {
      //   if (selectedDates.length > 0) {
      //     this.inputTarget.value = dateStr
      //   }
      // }
    }

    if (selectedLocale) {
      config.locale = selectedLocale
    }

    if (this.optionsValue.range) {
      config.mode = "range"
    }
    this.flatpickr = flatpickr(this.element.querySelector('.flatpickr'), config)
  }
}